export function getAncestors(element: HTMLElement) {
  const ancestors: HTMLElement[] = []
  let currentElement: HTMLElement | null = element

  while (currentElement) {
    ancestors.unshift(currentElement)
    currentElement = currentElement.parentElement
  }

  return ancestors.slice(0, -1)
}
